import script from "./PositionModal.vue?vue&type=script&setup=true&lang=js"
export * from "./PositionModal.vue?vue&type=script&setup=true&lang=js"

import "./PositionModal.vue?vue&type=style&index=0&id=4aa5ba5c&lang=less"

const __exports__ = script;

export default __exports__